import { useCallback } from "react";

import { useMutationWithToaster } from "hooks";

export function useTemplatePublish(onPublished = () => {}) {
  const mutationFactory = useCallback(() => {
    const query = `mutation publishTemplate($releaseId: ID!, $isGated: Boolean!, $isPublic: Boolean!) {
        publishTemplate(releaseId: $releaseId, isGated: $isGated, isPublic: $isPublic) {
          release {
            id
            documentationLink
            documentationTitle
            about
            title
            isDraft
            isCurrent
            releaseNumber
            publishedBy {
              name
              id
            }
            publishedDate
            createdBy {
              name
              id
            }
          }
        }
      }`;

    const resolver = ({ data: { publishTemplate } }) => {
      return {
        data: publishTemplate.release,
      };
    };

    return { query, resolver };
  }, []);

  const [publishTemplate, { loading }] = useMutationWithToaster(
    mutationFactory,
    { onDone: onPublished }
  );

  return {
    publishTemplate: (releaseId, isGated, isPublic) => {
      return publishTemplate(
        { releaseId, isGated, isPublic },
        {
          successMsg: "Successfully published template.",
          defaultErrorMsg: "Failed to publish template.",
        }
      );
    },
    loading: loading,
  };
}

export default useTemplatePublish;
